var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("web_accounn_center"))),
    ]),
    _c(
      "div",
      { staticClass: "account-list" },
      [
        _c("AccountFunplus", { attrs: { info: _vm.bindInfo.funplus_id } }),
        _c("AccountGoogle", { attrs: { info: _vm.bindInfo.google } }),
        _c("AccountFacebook", { attrs: { info: _vm.bindInfo.facebook } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }